export default __webpack_public_path__ + "static/media/stanbic.60a373e1.png";